import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import SpinLoading from '../spinLoading';

interface ImageProps {
  src: string;
  fallback?: string;
  placeholder?: boolean | React.ReactNode;
  preview?: boolean;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
}

const Image: React.FC<ImageProps> = ({
  src,
  fallback,
  placeholder,
  preview = false,
  alt = '',
  className,
  style,
}) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const handleLoad = () => setLoaded(true);
  const handleError = () => setError(true);
  const handlePreview = () => {
    if (preview && !error && loaded) {
      setShowPreview(true);
    }
  };

  const handleClosePreview = () => {
    setShowPreview(false);
  };

  const realSrc = error && fallback ? fallback : src;

  const renderPreview = () => {
    return ReactDOM.createPortal(
      <div className="wm-image-preview-mask" onClick={handleClosePreview}>
        <img className="wm-image-preview-img" src={realSrc} alt={alt} onClick={(e) => e.stopPropagation()} />
      </div>,
      document.body
    );
  };

  return (
    <>
      <div className="wm-image">
        <img
          src={realSrc}
          alt={alt}
          onLoad={handleLoad}
          onError={handleError}
          onClick={handlePreview}
          className={classNames(
            className,
            'wm-image-inner',
            {
              'wm-image-hidden': !loaded,
              'wm-image-clickable': preview,
            }
          )}
          style={style}
        />
        {!loaded && placeholder && (
          <div className="wm-image-placeholder">
            {placeholder === true ? <SpinLoading /> : placeholder}
          </div>
        )}
      </div>
      {showPreview && renderPreview()}
    </>
  );
};

export default Image;
